import type {ListUserManagementUsersSearchInput} from "./list-user-management-users.schema";
import {listUserManagementUsers} from "@project/sdk/user-management";
import {ListUserManagementUsersResponse} from "@project/sdk/user-management/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {userManagementUserKeys} from "../../../userManagementUser-keys";
import {listUserManagementUsersSearchSchema} from "./list-user-management-users.schema";

export function listUserManagementUsersQueryOptions(input: ListUserManagementUsersSearchInput) {
  const params = listUserManagementUsersSearchSchema.parse(input);
  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryKey: userManagementUserKeys.list(params),
    queryFn: async ({signal}) =>
      ListUserManagementUsersResponse.parse(await listUserManagementUsers(params, {signal})),
  });
}
